<script lang="ts">
  import Icon from '../components/Icon.svelte';
  import { onMount } from 'svelte';
  import { replace } from 'svelte-spa-router';
  import TopBar from '../components/TopBar.svelte';
  import { applySession } from '../lib/session';
  import { api, ApiError } from '../lib/api';
  import { getInitData, isInsideTelegram } from '../lib/telegram';
  import type { EventListItemDTO } from '../lib/types';

  let upcoming = $state<EventListItemDTO[] | null>(null);
  let past = $state<EventListItemDTO[] | null>(null);

  const MONTH_GEN = [
    'січ', 'лют', 'бер', 'квіт', 'трав', 'черв',
    'лип', 'серп', 'вер', 'жовт', 'лист', 'груд',
  ];
  function whenLabel(iso: string): string {
    const d = new Date(iso);
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getDate()} ${MONTH_GEN[d.getMonth()]}, ${p(d.getHours())}:${p(d.getMinutes())}`;
  }

  onMount(() => {
    (async () => {
      try {
        if (isInsideTelegram()) applySession(await api.authMe(getInitData()));
        else applySession(await api.authSession());
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) {
          replace(import.meta.env.DEV ? '/' : '/login');
          return;
        }
      }
      try {
        const [u, p] = await Promise.all([api.eventsUpcoming(), api.eventsPast()]);
        upcoming = u.items;
        past = p.items;
      } catch {
        upcoming = [];
        past = [];
      }
    })();
  });
</script>

<div class="screen">
  <TopBar title="Розклад" />
  <div class="scroll">
    <div class="sec-title">Найближчі події</div>
    {#if upcoming === null}
      <div class="placeholder">Завантажуємо…</div>
    {:else if upcoming.length === 0}
      <div class="placeholder">Поки що подій немає</div>
    {:else}
      {#each upcoming as ev (ev.id)}
        <a class="ev-row" class:locked={ev.locked} href={`#/event/${ev.id}`}>
          <div class="ev-icon"><Icon name="calendar-days" /></div>
          <div class="ev-main">
            <div class="ev-name">{ev.title}</div>
            <div class="ev-when">{whenLabel(ev.startsAt)}{#if ev.durationMin} · {ev.durationMin} хв{/if}</div>
          </div>
          {#if ev.locked}<div class="ev-lock" aria-label="Заблоковано"><Icon name="lock" label="Заблоковано" /></div>{:else}<span class="ev-chevron">›</span>{/if}
        </a>
      {/each}
    {/if}

    {#if past && past.length > 0}
      <div class="sec-title gap">Записи минулих</div>
      {#each past as ev (ev.id)}
        <a class="ev-row" class:locked={ev.locked} href={`#/event/${ev.id}`}>
          <div class="ev-icon"><Icon name="clapperboard" /></div>
          <div class="ev-main">
            <div class="ev-name">{ev.title}</div>
            <div class="ev-when">{whenLabel(ev.startsAt)}</div>
          </div>
          {#if ev.locked}<div class="ev-lock" aria-label="Заблоковано"><Icon name="lock" label="Заблоковано" /></div>{:else}<span class="ev-chevron">›</span>{/if}
        </a>
      {/each}
    {/if}
  </div>
</div>

<style>
  .screen { display: flex; flex-direction: column; flex: 1; min-height: 0; background: var(--bg); }
  .scroll { flex: 1; overflow-y: auto; padding: 18px; }
  .sec-title { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-muted); margin: 0 2px 10px; }
  .sec-title.gap { margin-top: 22px; }
  .placeholder {
    padding: 26px 16px; text-align: center; color: var(--text-muted); font-size: 13px;
    border: 1px dashed var(--border2); border-radius: 12px; background: var(--bg2);
  }
  .ev-row {
    display: flex; align-items: center; gap: 12px; padding: 12px 14px; margin-bottom: 8px;
    background: var(--bg2); border: 1px solid var(--border); border-radius: 12px; text-decoration: none;
  }
  .ev-row.locked { opacity: 0.7; }
  .ev-icon { font-size: 22px; flex-shrink: 0; }
  .ev-row.locked .ev-icon { filter: grayscale(0.7); }
  .ev-main { flex: 1; min-width: 0; }
  .ev-name { font-size: 14px; font-weight: 600; color: var(--text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .ev-when { font-size: 12px; color: var(--text-muted); margin-top: 3px; }
  .ev-chevron { flex-shrink: 0; color: var(--text-muted); font-size: 20px; }
  .ev-lock { flex-shrink: 0; font-size: 16px; }
</style>
